<button
    *ngIf="texts$ | async as text"
    tuiIconButton
    type="button"
    size="s"
    icon="tuiIconSpoilerDeleteLarge"
    appearance="icon"
    tuiHintDirection="top-left"
    tuiHintDescribe
    [tuiHint]="text.removeDetails"
    [focusable]="false"
    [disabled]="!!(disabled$ | async)"
    (click)="removeDetails()"
></button>
